import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Document} from '../../../shared/interface/document';
import {DocumentService} from '../../../shared/services/document.service';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {
  FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN,
  FILE_TYPE_ALLIANZ_CERT,
  FILE_TYPE_ALLIANZ_CERT_DOCUMENTS,
  FILE_TYPE_ALLIANZ_CERT_FRAUDS,
  FILE_TYPE_ALLIANZ_CERT_MY_CAR,
  FILE_TYPE_ANNEX,
  FILE_TYPE_ANNEX_COMMISSION_ATTACHMENT,
  FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
  FILE_TYPE_ANNEX_OFWCA_APPLICATION,
  FILE_TYPE_ANOTHER_MULTI,
  FILE_TYPE_AUTHORIZATION,
  FILE_TYPE_CERT_100P,
  FILE_TYPE_CERT_40P,
  FILE_TYPE_CONFIDENTIALITY_AGREEMENT,
  FILE_TYPE_CONTRACT,
  FILE_TYPE_CONTRACT_TERMINATION,
  FILE_TYPE_CONTRACT_WITH_EMPLOYEE,
  FILE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS,
  FILE_TYPE_DIPLOMA,
  FILE_TYPE_IDD_TRAINING_STATEMENT,
  FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA,
  FILE_TYPE_INITIAL_TRAINING,
  FILE_TYPE_KRK,
  FILE_TYPE_KRS_CEIDG,
  FILE_TYPE_OFWCA_APPLICATION,
  FILE_TYPE_PARTNER_DATA,
  FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU,
  FILE_TYPE_RECEIPT_PROTOCOL,
  FILE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE,
  FILE_TYPE_OVERCOMMISSION_AGREEMENT,
  FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM,
  FILE_TYPE_ANNEX_LEAD,
  FILE_TYPE_ANNEX_AUTOMATIC_BILLING, FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING,
  FILE_TYPE_MANDATE_QUESTIONNAIRE, IS_PUBLIC_AGENT_INFORMATION_DOCUMENT,
  FILE_TYPE_AML_CERTIFICATE, FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING,
} from '../../../shared/services/dict.service';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-document-details-view',
  templateUrl: './document-details-view.component.html',
  styleUrls: ['./document-details-view.component.scss']
})
export class DocumentDetailsViewComponent implements OnInit, OnDestroy {
  @Input() document: Observable<Document>;
  @Output() modifyClicked = new EventEmitter<any>();

  documentObject?: Document;
  userPermissions: ReplaySubject<UserPermissions>;

  readonly FILE_TYPE_CONTRACT = FILE_TYPE_CONTRACT;
  readonly FILE_TYPE_ANNEX = FILE_TYPE_ANNEX;
  readonly FILE_TYPE_CONTRACT_TERMINATION = FILE_TYPE_CONTRACT_TERMINATION;
  readonly FILE_TYPE_DIPLOMA = FILE_TYPE_DIPLOMA;
  readonly FILE_TYPE_AUTHORIZATION = FILE_TYPE_AUTHORIZATION;
  readonly FILE_TYPE_CERT_100P = FILE_TYPE_CERT_100P;
  readonly FILE_TYPE_KRS_CEIDG = FILE_TYPE_KRS_CEIDG;
  readonly FILE_TYPE_KRK = FILE_TYPE_KRK;
  readonly FILE_TYPE_CERT_40P = FILE_TYPE_CERT_40P;
  readonly FILE_TYPE_ALLIANZ_CERT = FILE_TYPE_ALLIANZ_CERT;
  readonly FILE_TYPE_ALLIANZ_CERT_FRAUDS = FILE_TYPE_ALLIANZ_CERT_FRAUDS;
  readonly FILE_TYPE_ALLIANZ_CERT_DOCUMENTS = FILE_TYPE_ALLIANZ_CERT_DOCUMENTS;
  readonly FILE_TYPE_ALLIANZ_CERT_MY_CAR = FILE_TYPE_ALLIANZ_CERT_MY_CAR;
  readonly FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA = FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA;
  readonly FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU = FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU;
  readonly FILE_TYPE_INITIAL_TRAINING = FILE_TYPE_INITIAL_TRAINING;
  readonly FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN = FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN;
  readonly FILE_TYPE_OFWCA_APPLICATION = FILE_TYPE_OFWCA_APPLICATION;
  readonly FILE_TYPE_IDD_TRAINING_STATEMENT = FILE_TYPE_IDD_TRAINING_STATEMENT;
  readonly FILE_TYPE_PARTNER_DATA = FILE_TYPE_PARTNER_DATA;
  readonly FILE_TYPE_ANNEX_COMMISSION_ATTACHMENT = FILE_TYPE_ANNEX_COMMISSION_ATTACHMENT;
  readonly FILE_TYPE_ANNEX_OFWCA_APPLICATION = FILE_TYPE_ANNEX_OFWCA_APPLICATION;
  readonly FILE_TYPE_RECEIPT_PROTOCOL = FILE_TYPE_RECEIPT_PROTOCOL;
  readonly FILE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS = FILE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS;
  readonly FILE_TYPE_CONFIDENTIALITY_AGREEMENT = FILE_TYPE_CONFIDENTIALITY_AGREEMENT;
  readonly FILE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE = FILE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE;
  readonly FILE_TYPE_ANOTHER_MULTI = FILE_TYPE_ANOTHER_MULTI;
  readonly  FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE = FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE;
  readonly FILE_TYPE_CONTRACT_WITH_EMPLOYEE = FILE_TYPE_CONTRACT_WITH_EMPLOYEE;
  readonly FILE_TYPE_OVERCOMMISSION_AGREEMENT = FILE_TYPE_OVERCOMMISSION_AGREEMENT;
  readonly FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM = FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM;
  readonly FILE_TYPE_ANNEX_LEAD = FILE_TYPE_ANNEX_LEAD;
  readonly FILE_TYPE_ANNEX_AUTOMATIC_BILLING = FILE_TYPE_ANNEX_AUTOMATIC_BILLING;
  readonly FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING = FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING;
  readonly FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING = FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING;
  readonly FILE_TYPE_MANDATE_QUESTIONNAIRE = FILE_TYPE_MANDATE_QUESTIONNAIRE;
  readonly FILE_TYPE_AML_CERTIFICATE = FILE_TYPE_AML_CERTIFICATE;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private documentService: DocumentService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private router: Router,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.document
      .pipe(takeUntil(this.destroyed$))
      .subscribe((document: Document) => this.documentObject = document);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  download(): void {
    this.documentService.downloadFile(this.documentObject.uuid);
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć dokument?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.documentService.deleteDocument(this.documentObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto dokument', '', {duration: 2000});
            this.router.navigate(['/dokumenty']);
          });
      }
    });
  }

  get publicLink(){
    return environment.apkUrl + '/public' + this.documentObject.location;
  }
}
